import { customization } from '@yola/ws-sdk';
import store from 'src/js/store';

const isBaseColorChanged = (colorKey, palette) => {
  const state = store.getState();
  const { colors, parentId } = palette;

  if (!parentId) return false;

  const parentPalette = customization.selectors.getColorPalette(state, parentId);
  if (!parentPalette) return false;

  return colors[colorKey] !== parentPalette.colors[colorKey];
};

export default isBaseColorChanged;
